module.exports = __webpack_public_path__ + "static/media/sapato-feminino-azul.a3fee226.jpg";